export default {
	events: {
		'ddc.page.view': [
			{
				excluded: '_trackAnalytics',
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.general]]',
						'[[mapping.configuration.sharedPayloads.pageview]]',
						'[[mapping.pagealias.additionalData]]'
					]
				}
			}
		],
		'ddc.inventory.filterSearch.click': [
			{
				payload: {
					shared: ['[[window._dl]]'],
					inventory_filter_category: '[[eventData.clickedFacetName]]',
					inventory_filter_value: '[[eventData.clickedFacetValue]]',
					inventory_filter_action: '[[lookup.eventData.checked]]',
					inventory_filters: '[[fn.getInventoryFilters()]]'
				}
			}
		],
		'ddc.link.hproductClick': [
			{
				payload: {
					shared: ['[[window._dl]]'],
					event_name: 'search inventory result click',
					site_events: {
						search_inventory_result_click: true
					},
					vehicles: {
						make: '[[eventData.make]]',
						model: '[[eventData.model]]',
						year: '[[eventData.year]]',
						bodyStyle: '[[eventData.bodyStyle]]',
						text: '[[eventData.text]]'
					}
				}
			}
		],
		'ddc.form.submission': [
			{
				logic: {
					mustExist: 'trackingId',
					validate: true
				},
				payload: {
					event_name:
						'[[mapping.form.event_name.[[eventData.trackingId]]]]',
					customer_lead_type:
						'[[mapping.form.customer_lead_type.[[eventData.trackingId]]]]',
					customer_lead_id: '[[eventData.formEventId]]',
					customer_lead_level:
						'[[mapping.form.customer_lead_level.[[fn.getFormContactMedium()]]]]',
					lead_form_variant: '[[eventData.formTrackingName]]',
					search_type: '{{UNDEFINED}}',
					exit_url: '{{UNDEFINED}}',
					site_events_array:
						'[[mapping.form.site_events_array.[[eventData.trackingId]]]]',
					site_events:
						'[[mapping.form.site_events.[[eventData.trackingId]]]]',
					shared: [
						'[[window._dl]]',
						{
							logic: {
								trackingId: 'INFO_REQUEST'
							},
							payload: {
								zip_code: '[[eventData.zip]] >> {{UNDEFINED}}'
							}
						},
						{
							logic: {
								trackingId: 'EPRICE'
							},
							payload: {
								zip_code: '[[eventData.zip]] >> {{UNDEFINED}}'
							}
						},
						{
							logic: {
								trackingId: 'SERVICE_APPT'
							},
							payload: {
								vehicle: '[[fn.getVehicleToService()]]'
							}
						}
					]
				}
			}
		],
		'ddc.link.clickToCall': {
			payload: {
				shared: [
					'[[window._dl]]',
					{
						logic: {
							mustInclude: {
								'eventData.clickToCallDepartment': [
									'here',
									'to',
									'help'
								]
							}
						},
						payload: {
							site_events: {
								click_to_call_dealer: true,
								'[[fn.formatClickToCallDepartment()]]': true
							}
						}
					},
					{
						logic: {
							mustNotInclude: {
								'eventData.clickToCallDepartment': [
									'here',
									'to',
									'help'
								]
							}
						},
						payload: {
							site_events: {
								click_to_call_dealer: true,
								'[[fn.formatClickToCallDepartment()]]': true,
								click_nav_cta: true
							}
						}
					}
				]
			}
		},
		'ddc.link.getDirections': {
			payload: {
				shared: ['[[window._dl]]'],
				event_name: 'get directions',
				site_events_array: 'get_directions',
				zip_code: '[[fn.getZipCodeViaDOM()]]',
				site_events: {
					get_directions: true
				}
			}
		},
		'ddc.link.generic': [
			{
				logic: {
					mustInclude: {
						'eventData.url': 'http'
					}
				},
				payload: {
					shared: ['[[window._dl]]'],
					event_name: 'exit link',
					exit_url: '[[eventData.url]]',
					site_events: {
						property_referral: true
					}
				}
			},
			{
				logic: {
					mustInclude: {
						'eventData.url': '/dealership/directions.htm'
					}
				},
				payload: {
					shared: ['[[window._dl]]'],
					event_name: 'get directions',
					site_events_array: 'get_directions',
					zip_code: '[[fn.getZipCodeViaDOM()]]',
					site_events: {
						get_directions: true
					}
				}
			}
		],
		'ddc.link.socialHeaderClick': {
			payload: {
				shared: ['[[window._dl]]'],
				exit_url: '[[eventData.url]]',
				event_name: 'social media follow',
				social_platform: '[[eventData.service]]',
				site_events: {
					property_referral: true,
					social_media_follow: true
				}
			}
		},
		'ddc.link.socialShare': {
			payload: {
				shared: ['[[window._dl]]'],
				exit_url: '[[eventData.url]]',
				event_name: 'social media follow',
				social_platform: '[[eventData.service]]',
				site_events: {
					property_referral: true,
					social_media_follow: true
				}
			}
		}
	}
};
